import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";
import useDynamicField from "developer/edit/hooks/useDynamicField";

type MinFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const MinField = (props: MinFieldProps) => {
  const {
    input: { value: max },
  } = useDynamicField<number | undefined>("fieldDef.max");

  const handleChange = (e: any) => {
    const { value } = e.target;
    if (value && Number(value)) {
      props.onChange(Math.abs(Number(value)));
    } else if (!value) {
      props.onChange(null);
    }
  };

  const error = !!max && !!props.value && props.value > max;
  const helperText = error ? "Min must be equal or less than Max" : undefined;

  return (
    <EditorVisualTextField
      id="min"
      size="small"
      label="Min"
      name={props.name}
      error={error}
      helperText={helperText}
      inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
      onChange={handleChange}
      value={props.value}
      fullWidth
    />
  );
};

export default MinField;
